import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import { settingApi } from './settingApi';

import type { ITeamItem, IUserItem } from '../setting.types';

// Define the type for state

type UserProfileDtlType = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string; // You can specify allowed roles if known, e.g., `"USER" | "ADMIN"`
  status: 'Active' | 'Inactive' | string; // Define more statuses if needed
  extNumber: string;
  userExtId: string;
  userExtPassword: string;
  ProfileURL?: string | null;
};

interface SettingState {
  teamList: { list: ITeamItem[]; total: number } | null;
  userList: { list: IUserItem[]; total: number } | null;
  userProfileDtl: UserProfileDtlType | null;
}

const initialState: SettingState = { teamList: null, userList: null, userProfileDtl: null };

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    setTeamList: (state, action: PayloadAction<{ list: ITeamItem[]; total: number }>) => {
      state.teamList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        settingApi.endpoints.getTeamList.matchFulfilled,
        (state, action: PayloadAction<{ list: ITeamItem[]; total: number }>) => {
          const { list, total } = action.payload;
          state.teamList = { list, total };
        }
      )
      .addMatcher(
        settingApi.endpoints.getUserList.matchFulfilled,
        (state, action: PayloadAction<{ list: IUserItem[]; total: number }>) => {
          const { list, total } = action.payload;
          state.userList = { list, total };
        }
      )
      .addMatcher(
        settingApi.endpoints.getUserDtl.matchFulfilled,
        (state, action: PayloadAction<UserProfileDtlType>) => {
          state.userProfileDtl = action.payload;
        }
      );
  },
});

export const { setTeamList } = settingSlice.actions;
export default settingSlice.reducer;
